export default "<lib-recuperar-senha></lib-recuperar-senha>\n";